var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "usp-page customer" }, [
    _c(
      "main",
      [
        _c("b-container", [
          _c("div", { staticClass: "parts" }, [
            _c(
              "div",
              { staticClass: "part" },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { lg: "6" } },
                      [
                        _c("h1", [_vm._v("Top-Bewerber finden!")]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Wie bei einer Dating-Plattform")]),
                        _vm._v(" "),
                        _c("CheckboxList", {
                          attrs: {
                            type: "positive",
                            items: [
                              { text: "Pool mit registrierten Bewerbern" },
                              { text: "Automatische Bewerber-Vorauswahl" },
                              { text: "Rangliste der Top-Bewerber (Eignung)" },
                              { text: "Kosten nur bei Erstkontakt" }
                            ]
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-col", { attrs: { "offset-lg": "1", lg: "5" } }, [
                      _c("div", { staticClass: "best-match-system" }, [
                        _c("h2", [_vm._v("Best-Match-System")]),
                        _vm._v(" "),
                        _c("h3", [_vm._v("Wie gut passt der Bewerber?")]),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: "/img/customer/usp/best-match-system.png",
                            alt: "Best-Match-System"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "best-match-system--avatar" },
                          [
                            _c("Avatar", {
                              attrs: { avatar: _vm.avatarCatNotebook }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("ButtonLine", {
                  staticClass: "mt-3 mt-ld-5",
                  attrs: { "middle-text": "skilldoo Job-Matching Plattform" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "part" },
              [
                _c("h2", { staticClass: "big" }, [
                  _vm._v("Nur 3 Schritte zum Top-Bewerber!")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: [
                      "how-it-works",
                      "how-it-works--full",
                      "how-it-works--center"
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "how-it-works--items" },
                      _vm._l(_vm.threeStepsItems, function(item, i) {
                        return _c(
                          "div",
                          {
                            class: {
                              "how-it-works--item": true,
                              "how-it-works--item-non-free": item.free === false
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "how-it-works--item-number" },
                              [_c("span", [_vm._v(_vm._s(i + 1))])]
                            ),
                            _vm._v(" "),
                            item.free !== undefined
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "how-it-works--item-free-info"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          item.free ? "Gratis" : "Faire Preise"
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "how-it-works--item-title" },
                              [_vm._v(_vm._s(item.title))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "how-it-works--item-sub-title" },
                              [_vm._v(_vm._s(item.subTitle))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "how-it-works--item-image" },
                              [
                                _c("img", {
                                  attrs: { src: item.image, alt: item.imageAlt }
                                })
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                ),
                _vm._v(" "),
                _c("ButtonLine", {
                  staticClass: "mt-4",
                  attrs: { "middle-text": "Zeit und Kosten sparen" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "part" },
              [
                _c("h2", { staticClass: "big" }, [_vm._v("Das Preismodell")]),
                _vm._v(" "),
                _c("h3", [
                  _vm._v("\n\t\t\t\t\t\tKosten nur bei Erstkontakt!"),
                  _c("br"),
                  _vm._v(
                    "\n\t\t\t\t\t\tSämtlicher Nachrichtenaustausch nach einem Erstkontakt ist nicht kostenpflichtig!\n\t\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("PriceTable"),
                _vm._v(" "),
                _c("ButtonLine", {
                  staticClass: "mt-4",
                  attrs: {
                    "middle-text": "Keine Kreditkarte/Zahlung vor Erstkontakt!"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "part top" },
              [
                _c("h2", { staticClass: "big" }, [_vm._v("Top für Sie!")]),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { lg: "4" } },
                      [
                        _c("CheckboxList", {
                          attrs: {
                            type: "positive",
                            items: [
                              { text: "Nur geeignete Top-Bewerber" },
                              { text: "Zeit- und Kostenersparnis" },
                              { text: "Direktkontakt zu Bewerbern" },
                              { text: "Zusagen und Absagen erteilen" }
                            ]
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "mt-4 mt-md-0", attrs: { lg: "4" } },
                      [
                        _c("CheckboxList", {
                          attrs: {
                            type: "negative",
                            items: [
                              { text: "Keine Vermittlungsprovision" },
                              { text: "Keine Inserate texten/gestalten" },
                              { text: "Keine Inseratekosten" },
                              { text: "Kein Auswahlstress" }
                            ]
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-col", { attrs: { lg: "4" } }, [
                      _c(
                        "div",
                        { staticClass: "top-avatar-container" },
                        [
                          _c("Avatar", {
                            attrs: { avatar: _vm.avatarHoldingNothing }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("ButtonLine", {
                  attrs: { "middle-text": "Kosten nur bei Erstkontakt!" }
                })
              ],
              1
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }